var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDelivered(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinejoin: "round",
    strokeWidth: 0.85,
    d: "M26.673 11L16.255 21.419l-2.918-2.917-2.917 2.917 5.835 5.834 13.336-13.336z"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzOSIgaGVpZ2h0PSIzOSIgdmlld0JveD0iMCAwIDM5IDM5Ij4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPGNpcmNsZSBjeD0iMTkuNSIgY3k9IjE5LjUiIHI9IjE5LjUiIGZpbGw9IiNFREVERUQiLz4KICAgIDxwb2x5Z29uIHN0cm9rZT0iI0ZGRiIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIuODUiIHBvaW50cz0iMTYuNjczIDAgNi4yNTUgMTAuNDE5IDMuMzM3IDcuNTAyIC40MiAxMC40MTkgNi4yNTUgMTYuMjUzIDE5LjU5MSAyLjkxNyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTAgMTEpIi8+CiAgPC9nPgo8L3N2Zz4K";
export { SvgDelivered as ReactComponent };